import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { ActionCableConsumer } from "react-actioncable-provider";
import { handleAlert } from "../../../../services/AlertService";
import { useTranslation } from 'react-i18next';
import indexedDBService from '../../../../services/IndexedDBService';
import { useHistory } from "react-router-dom";
import { getRide } from "../../../../services/RideService";

const ActiveRides = () => {
  const { t } = useTranslation();
  const [activeRideData, setActiveRideData] = useState(null);
  const [showActiveRide, setShowActiveRide] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const loadActiveRide = async () => {
      try {
        const activeRide = await indexedDBService.getNotificationData('activeRide');
        if (!!activeRide) {
          getRide(activeRide).then(response => {
            const ride = response.data.ride;
            if (ride.status === 'pending' || ride.status === 'completed' || ride.status === 'cancelled') {
              indexedDBService.removeNotificationData('activeRide');
              setActiveRideData(null);
              setShowActiveRide(false);
            } else {
              setActiveRideData(ride.id);
              setShowActiveRide(!!ride && !history.location.pathname.includes('rides'));
            }
          }).catch(error => {
            console.error('Failed to load active ride:', error);
            indexedDBService.removeNotificationData('activeRide');
            setActiveRideData(null);
            setShowActiveRide(false);
          });
        }
      } catch (error) {
        console.error('Failed to load active ride:', error);
        setActiveRideData(null);
        setShowActiveRide(false);
      }
    };

    loadActiveRide();
  }, [history.location.pathname]);

  const changeOrderStatus = async (data) => {
    handleAlert('default', t(`orderStatuses.${data.order.status}`), data.message);
    if (data.order.status === 'completed' || data.order.status === 'canceled') {
      await indexedDBService.removeNotificationData('activeRide');
      setActiveRideData(null);
      setShowActiveRide(false);
    }
  };

  return (
    <>
      {showActiveRide && activeRideData &&
        <>
          <ActionCableConsumer channel={{ channel: 'RideChannel', room: activeRideData }}
            onReceived={(data) => changeOrderStatus(data)}
          />
          <div className='active-ride opacity'>
            <Link to={`/rides/${activeRideData}`}>
              <span className='emoji mr-2' role="img" aria-label={'label'}>
                {String.fromCodePoint('0x1F695')}
              </span>
            </Link>
          </div>
        </>}
    </>
  );
};

export default ActiveRides;